export default {
  en: {
    voting: {
      afterward_results: 'Result will be published at the end of voting.',
      closed: 'Voting is closed',
    },
    x_members_voted: {
      zero: 'Vote now!',
      one: '1 member voted',
      other: '%{count} members voted',
    },
  },
};
